import { DialogComponent } from '@theme/dialog';

/**
 * Side drawer for region and language selection (mirrors cart drawer dialog behavior).
 *
 * @extends {DialogComponent}
 */
class LocalizationDrawerComponent extends DialogComponent {
  open() {
    this.showDialog();
  }

  close() {
    this.closeDialog();
  }
}

if (!customElements.get('localization-drawer-component')) {
  customElements.define('localization-drawer-component', LocalizationDrawerComponent);
}
